import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedHttp } from '../../../services/http-client.service';
import { UtilityService } from '../../../services/utility.service';
import { WebClientService } from '../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Confirm Component
 */
let ConfirmGuestComponent = class ConfirmGuestComponent {
    constructor(httpClient, route, router, convertor, webSettingsService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.route = route;
        this.router = router;
        this.convertor = convertor;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.confirmData = {};
        this.textColor = '';
        this.accentColor = '';
        this.secondColor = '';
        this.backColor = '';
        this.mainColor = '';
        this.webSettingsService.getSettings().subscribe(data => {
            if (!this.webSettingsService.applySettings('GUEST_USER.ON')) {
                this.router.navigate(['/']);
            }
        });
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
        });
        this.userType = 'guest';
        this.orderType = localStorage.getItem('orderType');
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.getOrderData(this.orderId + '');
        });
    }
    ngAfterViewInit() {
    }
    getOrderData(oid) {
        if (oid !== '') {
            this.httpClient.get('market/order/guest/' + oid).subscribe((data) => {
                this.confirmData = data;
                this.meanOfPayment = this.confirmData.mean_of_payment.verbose_id;
                this.nameOfCurrency = this.confirmData.cryptocurrency;
                this.convertor.convertToShortcut(this.nameOfCurrency).then(result => {
                    this.currency = result + '';
                    this.httpClient.get('market/feesandlimits?ecurrency=' + this.currency + '&mop=' + this.meanOfPayment + '&user_type=' + this.userType + '&order_type=' + this.orderType).subscribe((data) => {
                        this.provision = data[this.orderType][this.currency][this.meanOfPayment][this.userType].fee;
                    });
                });
            });
        }
    }
    confirmedCardTransaction(isCard) {
    }
};
ConfirmGuestComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: Router },
    { type: UtilityService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ConfirmGuestComponent = __decorate([
    Component({
        selector: 'ecd-guest-confirm',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./confirm.component.html")).default
    })
], ConfirmGuestComponent);
export { ConfirmGuestComponent };
